import { type ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from '@mp/graphql/generated';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';

export const MissingAssignmentCheckListInformationGql = graphql(`
  query GetMissingAssignmentCheckListInformationForAssignmentDetailsHeader(
    $has_missing_information: Boolean = false
    $input: AssignmentRequestQueryInput
  ) {
    assignmentRequests(input: $input) {
      assignment_id
      has_missing_information @include(if: $has_missing_information)
    }
  }
`);

type MissingAssignmentCheckListInformationProps = ResultOf<
  typeof MissingAssignmentCheckListInformationGql
>;

export const useMissingAssignmentChecklistInfoForAssignmentDetails = (assignmentId?: number) => {
  const { data, isLoading } = useGraphQLQuery<MissingAssignmentCheckListInformationProps>({
    queryKey: ['missingAssignmentChecklist', assignmentId],
    operationName: 'GetMissingAssignmentCheckListInformationForAssignmentDetailsHeader',
    query: MissingAssignmentCheckListInformationGql,
    variables: {
      has_missing_information: true,
      input: {
        search: { assignment_status: ['matched', 'available'], statuses: ['applied', 'pre_apply'] },
      },
    },
  });
  const missingAssignmentCheckListInformation = data?.assignmentRequests || [];

  const assignmentHasMissingInformation = () =>
    missingAssignmentCheckListInformation?.some(
      (assignmentRequest) =>
        assignmentRequest.has_missing_information &&
        assignmentRequest.assignment_id === assignmentId,
    );

  return {
    isAssignmentApplicationMissingInformation: !isLoading && assignmentHasMissingInformation(),
  };
};
